export const downloadCanvas = (c, {mimeString, fileName}) => {
    const link = document.createElement("a");
    link.href = c.toDataURL(mimeString);
    link.target = "_blank";
    link.setAttribute("download", fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
    link.remove();
};

